import React from "react";
import cx from "classnames";
import type { ButtonProps } from "components/Button/Button.tsx";
import Button from "components/Button/Button.tsx";
import "./ButtonIcon.scss";

/**
 * TODO
 * - Button Icon should exist in round by itself and only a ButtonGroup component should make it go flat on one end
 * - Add validation to material icon names? ie if an icon with that name does not exist, log a warning
 * @param className
 * @param children
 * @param rest
 * @constructor
 */

export type ButtonIconProps = {
  iconType?: "icon" | "text";
  kind?: "neutral" | "error" | "active" | "warning" | "success";
  size?: "primary" | "small";
  onContextMenu?: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & ButtonProps;

const ButtonIcon = ({
  className,
  children,
  kind = "neutral",
  iconType = "icon",
  size = "primary",
  ...rest
}: ButtonIconProps) => {
  return (
    <Button
      data-kind={kind}
      data-size={size}
      className={cx(
        `button-icon btn-icon ${iconType === "icon" ? "material-icons" : "text"}`,
        className,
      )}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ButtonIcon;
